import { render, staticRenderFns } from "./RUWiseMateriality.vue?vue&type=template&id=5c1429a5&scoped=true"
import script from "./RUWiseMateriality.vue?vue&type=script&lang=js"
export * from "./RUWiseMateriality.vue?vue&type=script&lang=js"
import style0 from "./RUWiseMateriality.vue?vue&type=style&index=0&id=5c1429a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1429a5",
  null
  
)

export default component.exports